/**
 * Bangladesh (+880) phone helpers — same rules as mobile login.jsx.
 * Leading trunk 0 is kept while typing and stripped only when building the full number.
 */

const BD_DIAL_CODE = '+880'

export function formatPhoneNumber(text) {
  const cleaned = text.replace(/\D/g, '')
  if (cleaned.length <= 4) return cleaned
  if (cleaned.length <= 10) {
    return `${cleaned.slice(0, 4)}-${cleaned.slice(4)}`
  }
  return `${cleaned.slice(0, 4)}-${cleaned.slice(4, 10)}`
}

export function getPhoneDigits(phone) {
  return (phone || '').replace(/\D/g, '')
}

/** Format value as the user types (BD branch of login.jsx handlePhoneChange). */
export function formatBdPhoneInput(text) {
  const cleaned = text.replace(/\D/g, '').slice(0, 10)
  return formatPhoneNumber(cleaned)
}

export function buildBdFullPhone(phone) {
  let localDigits = getPhoneDigits(phone)
  if (localDigits.startsWith('0')) {
    localDigits = localDigits.slice(1)
  }
  return BD_DIAL_CODE + localDigits
}

export function isValidPhoneLength(phone, minDigits = 7, maxDigits = Infinity) {
  const len = getPhoneDigits(phone).length
  return len >= minDigits && len <= maxDigits
}
